import * as React from 'react';

export const MiniModeIconOutline: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9.01 24.003c.827 0 1.5-.673 1.5-1.5v-1.5c0-.827-.673-1.5-1.5-1.5h-7.5c-.827 0-1.5.673-1.5 1.5v1.5c0 .827.673 1.5 1.5 1.5h7.5Zm0-1.5h-7.5v-1.5h7.5v1.5Zm5.25-4.5a.75.75 0 0 0 0-1.5h-2.689l5.845-5.845a.743.743 0 0 0 .22-.53c0-.2-.078-.389-.22-.53a.743.743 0 0 0-.53-.22c-.2 0-.389.078-.53.22l-5.845 5.845v-2.689a.75.75 0 0 0-1.5 0v4.5c0 .087.016.174.047.258l.006.017c.08.195.229.343.412.419l.026.01c.082.031.17.047.259.047h4.499v-.002Zm7.5-3a2.252 2.252 0 0 0 2.25-2.25v-10.5a2.252 2.252 0 0 0-2.25-2.25H8.26a2.252 2.252 0 0 0-2.25 2.25v10.5a.75.75 0 0 0 1.5 0v-6.75h15v6.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 0-.75.75c0 .414 5.25.75 5.25.75ZM7.51 4.503v-2.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75v2.25h-15Z"
    />
  </svg>
);
